import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Grid,
  Group,
  Input,
  NumberFormatter,
  rem,
  Select,
  Text,
  Tooltip,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBuildingWarehouse,
  IconFileExport,
  IconSearch,
  IconTimeDuration15,
  IconUsers,
} from "@tabler/icons-react";
import { addMonths } from "date-fns";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import {
  keySearchGeneralSalesStatement,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../../_base/component/_layout/_breadcrumb";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../../common/FormatDate/FormatDate";
import { BASE_API_MDM } from "../../../../config";
import { _localization } from "../../../../config/location";
import { green } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  SelectListItem,
  SelectListItemModel,
} from "../../../../model/SelectListItem";
import { reportItemSales } from "../../../../model/TblOrderHeader";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import {
  useDebouncedCallback,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
  useIsFirstRender,
} from "@mantine/hooks";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
const GeneralSalesStatement = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<reportItemSales[]>([]);
  const [dataSum, setDataSum] = useState<any>([]);
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);

  //Kho
  const [dataInventory, setDataInventory] = useState<SelectListItemModel[]>([]);
  //Bộ phận
  const [dataDepartment, setDataDepartment] = useState<SelectListItemModel[]>(
    [],
  );
  //Khách hàng
  const [keySearchCustomer, setKeySearchCustomer] = useState<string>("");
  const [debounceKeySearchCustomer] = useDebouncedValue<string>(
    keySearchCustomer,
    300,
  );
  const [dataCustomer, setDataCustomer] = useState<SelectListItemModel[]>([]);
  const [dataCustomerSearch, setDataCustomerSearch] = useState<ComboboxItem[]>(
    [],
  );

  //Chi nhánh
  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);

  //Mã sản phẩm
  const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);

  //Mã nhân viên
  const [dataEmployee, setDataEmployee] = useState<SelectListItemModel[]>([]);

  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 3, xl: 2 };

  //Lấy userLoginHeader trong localStorage
  const userLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}",
  );
  const firstRender = useIsFirstRender();
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const _searchJson = (() => {
    try {
      const storedValue = sessionStorage.getItem(
        keySearchGeneralSalesStatement,
      );
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error("Lỗi khi parse JSON từ sessionStorage:", error);
      return null;
    }
  })();
  // console.log("searchJson", _searchJson);
  const innitStateSearch = React.useMemo(
    () => ({
      keySearch:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KeySearch
          : "",
      StartTime:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.StartTime
          : new Date(
              new Date(
                new Date().setMonth(new Date().getMonth() - 1),
              ).getTime() +
                7 * 3600 * 1000,
            )?.toISOString(),
      EndTime:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.EndTime
          : new Date(new Date().getTime() + 7 * 3600 * 1000).toISOString(),
      Cnids:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.Cnids !== ""
          ? _searchJson.Cnids
          : userLoginHeader?.branchId?.toString() || "",
      KhoIds:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KhoIds
          : "",
      Bpids:
        firstRender && _searchJson && checkedPinSearch ? _searchJson.Bpids : "",
      KHids:
        firstRender && _searchJson && checkedPinSearch ? _searchJson.KHids : "",
      MaNvkd:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.MaNvkd
          : "",
      MaSp:
        firstRender && _searchJson && checkedPinSearch ? _searchJson.MaSp : "",
      MaKenh:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.MaKenh
          : "",
      Sdt:
        firstRender && _searchJson && checkedPinSearch ? _searchJson.Sdt : "",
    }),
    [firstRender, _searchJson],
  );

  const formSeachInput = useForm<{
    keySearch: string;
    StartTime: string;
    EndTime: string;
    Cnids: string;
    KhoIds: string;
    Bpids: string;
    KHids: string;
    MaNvkd: string; //Mã nhân viên kinh doanh
    MaSp: string; //Mã sản phẩm
    MaKenh: string; //Mã kênh bán hàng
    Sdt: string; //Số điện thoại
  }>({
    mode: "uncontrolled",
    // initialValues: {
    //   keySearch: "",
    //   StartTime: new Date().toISOString(),
    //   EndTime: "",
    //   Cnids: userLoginHeader ? userLoginHeader?.branchId.toString() : "", //chi nhánh
    //   // Cnids: "", //chi nhánh
    //   KhoIds: "", //kho
    //   Bpids: "", //bộ phận
    //   KHids: "", //khách hàng
    //   MaNvkd: "", //Mã nhân viên kinh doanh
    //   MaSp: "", //Mã sản phẩm
    //   MaKenh: "", //Mã kênh bán hàng
    //   Sdt: "", //Số điện thoại
    // },
    initialValues: innitStateSearch,
  });

  // const [search, setSearch] = useState({
  //   Cnids: [], //chi nhánh
  //   KhoIds: [], //kho
  //   Bpids: [], //bộ phận
  //   KHids: [], //khách hàng
  // });
  // const handleChangeSearchValue = (value: string[] | null, key: string) => {
  //   setSearch((prevData) => ({
  //     ...prevData,
  //     [key]: value ? value : [],
  //   }));
  // };

  const fetchData = async () => {
    const fromDate = new Date(formSeachInput.getValues()?.StartTime);
    const toDate = new Date(formSeachInput.getValues()?.EndTime);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);

    if (toDate > maxAllowedDate) {
      NotificationExtension.Fails("Chỉ được phép lọc dữ liệu trong 1 tháng !");
    } else {
      setIsLoading(true);
      setIsRefetching(true);

      // Tạo object keySearch
      const keySearch = {
        KeySearch: formSeachInput.getValues().keySearch || "",
        StartTime: formSeachInput.getValues().StartTime || "",
        EndTime: formSeachInput.getValues().EndTime || "",
        Cnids: formSeachInput.getValues().Cnids || "",
        KhoIds: formSeachInput.getValues().KhoIds || "",
        Bpids: formSeachInput.getValues().Bpids || "",
        KHids: formSeachInput.getValues().KHids || "",
        MaNvkd: formSeachInput.getValues().MaNvkd || "",
        MaSp: formSeachInput.getValues().MaSp || "",
        MaKenh: formSeachInput.getValues().MaKenh || "",
        Sdt: formSeachInput.getValues().Sdt || "",
      };

      try {
        // Tạo URL từ keySearch
        let url = `/api/v1/TblOrderHeader/report-item-sales?Skip=${
          pagination.pageIndex * pagination.pageSize
        }&Take=${pagination.pageSize}`;
        Object.entries(keySearch).forEach(([key, value]) => {
          if (value) {
            url += `&${key}=${encodeURIComponent(value)}`;
          }
        });

        const response = await repositoryMdm.get<MessageResponse<any>>(url);
        if (response && response.success) {
          setIsCallFirst(true);
          const result = response.data;
          const dataSumAPI = result?.filter(
            (item: any) => item.order_Id === -1,
          );
          setDataSum(dataSumAPI);
          setData(result?.filter((item: any) => item.order_Id !== -1));
          setRowCount(response.totalCount);
        } else {
          setData([]);
          setRowCount(0);
          setIsLoading(false);
        }
      } catch (error) {
        setData([]);
        console.error("Error fetching data:", error);
      } finally {
        // Lưu keySearch vào sessionStorage
        sessionStorage.setItem(
          keySearchGeneralSalesStatement,
          JSON.stringify(keySearch),
        );
        setIsLoading(false);
        setIsRefetching(false);
      }
    }
  };

  // Chuyển hướng đến trang đơn hàng chi tiết
  const handleCheckView = async (row: any) => {
    if (row.original.tlHd == "3") {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.ma_Ct}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        navigate("/sell/view-return-order", {
          state: {
            id: row.original.order_Id,
            orderNumber: row.original.ma_Ct,
            orderType: row.original.tl_Hd,
            actionType: "view",
          },
        });
      }
    } else {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.ma_Ct}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        navigate("/sell/view-order", {
          state: {
            id: row.original.order_Id,
            orderNumber: row.original.ma_Ct,
            orderType: row.original.tl_Hd,
            actionType: "view",
          },
        });
      }
    }
  };
  const columns = React.useMemo<MRT_ColumnDef<reportItemSales>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "ma_Ct",
        header: "Mã chứng từ",
        size: 170,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Tooltip label="Xem chi tiết">
              <Badge
                variant="dot"
                radius="xs"
                onDoubleClick={() => handleCheckView(row)}
                style={{
                  cursor: "pointer",
                }}
                size="md"
                color={renderedCellValue === null ? "red" : green.base}
              >
                {renderedCellValue}
              </Badge>
            </Tooltip>
          </>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text c="red" fw={800}>
                Tổng
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "attribute6",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => (
          <Text tt={"uppercase"} fw={500} size="sm">
            {getDataStatus(renderedCellValue?.toString() ?? "")}
          </Text>
        ),
      },
      {
        accessorKey: "ngay_Ct",
        header: "Ngày chứng từ",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        sortingFn: (a, b) => {
          const dateA = new Date(a.original?.ngay_Ct ?? "");
          const dateB = new Date(b.original?.ngay_Ct ?? "");
          return dateA.getTime() - dateB.getTime();
        },
      },
      {
        accessorKey: "ma_Bp",
        header: "Mã bộ phận",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {renderedCellValue ? (
              <>
                <Badge variant="light" color="blue">
                  {renderedCellValue}
                </Badge>
              </>
            ) : null}
          </>
        ),
      },
      {
        accessorKey: "ma_Cn",
        header: "Mã chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Cn",
        header: "Tên chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ma_Kho",
        header: "Mã kho",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Badge variant="light" color="blue">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "ten_Kho",
        header: "Tên kho",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ma_Nvkd",
        header: "Mã nhân viên",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Nvkd",
        header: "Tên nhân viên kinh doanh",
        size: 225,
      },
      {
        accessorKey: "ma_Ql",
        header: "Mã quản lý",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Ql",
        header: "Tên quản lý",
      },
      {
        accessorKey: "ma_Kt",
        header: "Mã kế toán",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Ke_Toan",
        header: "Tên kế toán",
      },
      {
        accessorKey: "ma_Kenh",
        header: "Mã kênh bán",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Kenh",
        header: "Tên kênh bán",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "attribute4",
        header: "Mã đối tượng công nợ",
        size: 225,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ma_Kh",
        header: "Mã khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Kh",
        header: "Tên khách hàng",
      },
      {
        accessorKey: "dia_Chi_Kh",
        header: "Địa chỉ khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "sdt",
        header: "Số điện thoại",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "email",
        header: "Email",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ma_Thue_Kh",
        header: "Mã thuế khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ma_Tinh",
        header: "Mã tỉnh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Tinh",
        header: "Tên tỉnh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ma_Quan",
        header: "Mã quận",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Quan",
        header: "Tên quận",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ma_Phuong",
        header: "Mã phường",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Phuong",
        header: "Tên phường",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "attribute1",
        header: "Loại hóa đơn",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tt_Hd",
        header: "Trạng thái hóa đơn",
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge size="sm" color="green">
              {renderedCellValue === "DON_HANG_HOAN_THANH"
                ? "Đơn hàng hoàn thành"
                : ""}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "shipping_Code",
        header: "Mã vận đơn",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "shipng_Type",
        header: "Hình thức giao hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "shipping_Status",
        header: "Trạng thái giao hàng",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge size="sm" color="cyan">
              {renderedCellValue === null ? "KHONG_YEU_CAU" : renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "shipping_Priority",
        header: "Ưu tiên giao vận",
        size: 200,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "shiping_Vendor",
        header: "Đơn vị giao vận",
        size: 200,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "shipping_Date",
        header: "Ngày giao hàng",
        size: 225,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "shipping_Finish_Date",
        header: "Ngày hoàn thành giao hàng",
        size: 225,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "shipping_Note",
        header: "Ghi chú GV",
        size: 200,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "t_Tien_Dh",
        header: "Tổng tiền hóa đơn",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.t_Tien_Dh)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "t_Ck",
        header: "Tổng tiền chiết khấu",
        size: 225,
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.t_Ck)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "dt_Sau_Ck",
        header: "Doanh thu sau chiết khấu",
        size: 225,
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.dtSauCk || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.dt_Sau_Ck)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "t_Gg",
        header: "Tổng giảm giá",
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tGg || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.t_Gg)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "t_Tien_Voucher",
        header: "Tiền voucher",
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
      },
      {
        accessorKey: "t_Tien_Tra",
        header: "Tổng tiền trả",
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tTienTra || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.t_Tien_Tra)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "t_Tien_Con",
        header: "Tổng tiền còn phải trả",
        size: 200,
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tTienCon || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.t_Tien_Con)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "ngay_Duyet",
        header: "Ngày duyệt giảm giá",
        size: 200,
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "nguoi_Duyet_Gg",
        header: "Người duyệt giảm giá",
        size: 190,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {/* <AvatarUtils
              value={row.original.nguoiDuyetGg?.split("-")[0] || ""}
            /> */}
            {renderedCellValue}
          </>
        ),
      },
      {
        accessorKey: "ma_Item",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Item",
        header: "Tên sản phẩm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ma_Nhom_Vt",
        header: "Mã nhóm vật tư",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ten_Nhom_Vt",
        header: "Tên nhóm vật tư",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "uom",
        header: "Đơn vị tính",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "so_Luong",
        header: "Số lượng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.soLuong || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.so_Luong)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "price_On_Price_List",
        header: "Đơn giá bán",
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) =>
                sum + (row.original.priceOnPriceList || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.price_On_Price_List)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "gia_Von",
        header: "Giá vốn",
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.giaVon || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.gia_Von)}
              </Text>
            </div>
          );
        },
      },

      {
        accessorKey: "tien_Gia_Von",
        header: "Tiền giá vốn",
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tienGiaVon || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.tien_Gia_Von)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tien_Ck",
        header: "Chiết khấu trên sản phẩm",
        size: 225,
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tienCk || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.tien_Ck)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tien_Gg",
        header: "Xin giảm giá trên sản phẩm ",
        size: 225,
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) =>
                sum + (row.original.totalLineAmount || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.tien_Gg)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "attribute8",
        header: "Đơn giá sau CK/GG",
        size: 225,
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={600} size="sm">
            {renderedCellValue !== undefined &&
            !isNaN(Number(renderedCellValue)) ? (
              <NumberFormatter
                value={Number(renderedCellValue)}
                thousandSeparator=","
              />
            ) : (
              <></>
            )}
          </Text>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tienSauCkGg || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.tien_Sau_Ck_Gg)}
              </Text>
            </div>
          );
        },
      },

      {
        accessorKey: "tg_Nguoi_Sua",
        header: "Thời gian người sửa",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ma_Nguoi_Sua",
        header: "Mã Người sửa",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "attribute5",
        header: "Xuất hóa đơn",
        Cell: ({ renderedCellValue, row }) => (
          <>
            {renderedCellValue === null
              ? null
              : renderedCellValue === "Có"
                ? `Có xuất hóa đơn-${row.original?.ma_Ct}`
                : "Không xuất hóa đơn"}
          </>
        ),
      },
      {
        accessorKey: "tong_Tien_Ck",
        header: "Tổng CK",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={600} size="sm">
            {renderedCellValue !== undefined &&
            !isNaN(Number(renderedCellValue)) ? (
              <NumberFormatter
                value={Number(renderedCellValue)}
                thousandSeparator=","
              />
            ) : (
              <></>
            )}
          </Text>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.tong_Tien_Ck)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tong_Tien_Gg",
        header: "Tổng GG",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={600} size="sm">
            {renderedCellValue !== undefined &&
            !isNaN(Number(renderedCellValue)) ? (
              <NumberFormatter
                value={Number(renderedCellValue)}
                thousandSeparator=","
              />
            ) : (
              <></>
            )}
          </Text>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.tong_Tien_Gg)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "total_Line_Amount",
        header: "Tổng tiền hàng",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={600} size="sm">
            {renderedCellValue !== undefined &&
            !isNaN(Number(renderedCellValue)) ? (
              <NumberFormatter
                value={Number(renderedCellValue)}
                thousandSeparator=","
              />
            ) : (
              <></>
            )}
          </Text>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.total_Line_Amount)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tien_Sau_Ck_Gg",
        header: "Tổng tiền sản phẩm sau CK/GG",
        size: 250,
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={600} size="sm">
            {renderedCellValue !== undefined &&
            !isNaN(Number(renderedCellValue)) ? (
              <NumberFormatter
                value={Number(renderedCellValue)}
                thousandSeparator=","
              />
            ) : (
              <></>
            )}
          </Text>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum[0]?.tien_Sau_Ck_Gg)}
              </Text>
            </div>
          );
        },
      },
    ],
    [dataSum],
  );

  const getDataStatus = (value: string) => {
    switch (value) {
      // case null:
      //   return "Không yêu cầu";
      case "THANH_CONG":
        return "Thành công";
      case "PHAN_CONG":
        return "Phân công";
      case "TAO_MOI":
        return "Tạo mới";
      case "THAT_BAI_DO_KH":
        return "Thất bại do khách hàng";
      case "NHAP_LAI":
        return "Nhập lại";
      case "DEN_NOI":
        return "Đến nơi";
      case "DANG_GIAO":
        return "Đang giao";
      case "DA_YEU_CAU":
        return "Đã yêu cầu";
      case "HUY_PHAN_CONG":
        return "Hủy phân công";
      case "THAT_BAI_DO_HACOM":
        return "Thất bại do HACOM";
      case "TIEP_NHAN":
        return "Tiếp nhận";
      case "NHAP_LAI_MOT_PHAN":
        return "Nhập lại một phần";
      case "NOI_CHUYEN":
        return "Nối chuyến";
    }
  };

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enablePagination: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "ma_Ct"],
        // right: ["tTienDh", "action"],
      },
      // columnVisibility: { id: true },
      density: "xs",
      pagination: {
        pageSize: 50,
        pageIndex: 0,
      },
    },
    enableStickyFooter: true,
    enableRowSelection: false,
    enableToolbarInternalActions: false,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  // // Lấy danh sách mã chi nhánh
  // const DataBranchCode = async () => {
  //   try {
  //     const response = await repositoryDelivery.get(
  //       `api/v1/TblDmMasterOrg/get-select`
  //     );

  //     if (response && response.success) {
  //       const transformedData = response.data.map((item: any) => ({
  //         value: item.value,
  //         label: item.value + " - " + item.text,
  //       }));
  //       setDataBranchCode(transformedData);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return;
  //   }
  // };

  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  // Lấy danh sách kho

  const fetchDataKho = async () => {
    try {
      // if (
      //   userLogin &&
      //   userLogin.branchId !== null &&
      //   userLogin.branchId !== undefined
      // ) {
      //   const response = await repositoryPos.get(
      //     `/api/v1/TblDmInventory/get-select-by-branch?branchId=${userLogin?.branchId}`
      //   );
      //   if (response && response.success) {
      //     const transformedData = response.data.map((item: any) => ({
      //       value: String(item.inventoryId),
      //       label: item.inventoryCode + " - " + item.inventoryName,
      //     }));
      //     setDataInventory(transformedData);
      //   } else {
      //     setDataInventory([]);
      //   }
      // } else {
      //   const response = await repositoryPos.get(
      //     `/api/v1/TblDmInventory/get-all?checkAuth=true`
      //   );
      //   if (response && response.success) {
      //     const transformedData = response.data.map((item: any) => ({
      //       value: item.value,
      //       label: item.text,
      //     }));
      //     setDataInventory(transformedData);
      //   } else {
      //     setDataInventory([]);
      //   }
      // }
      if (
        formSeachInput.getValues().Cnids &&
        formSeachInput.getValues().Cnids.length > 0
      ) {
        const response = await repositoryPos.get(
          `/api/v1/TblDmInventory/get-select-by-branch?branchId=${
            formSeachInput.getValues().Cnids
          }`,
        );
        if (response && response.success) {
          const transformedData = response.data.map((item: any) => ({
            value: String(item.inventoryId),
            label: item.inventoryCode + " - " + item.inventoryName,
          }));
          setDataInventory(transformedData);
        } else {
          setDataInventory([]);
        }
      } else {
        const response = await repositoryPos.get(
          `/api/v1/TblDmInventory/get-all?checkAuth=true`,
        );
        if (response && response.success) {
          const transformedData = response.data
            .filter((i: any) => i.value !== null && i.text !== null)
            .map((item: any) => ({
              value: item.value,
              label: item.text,
            }));
          setDataInventory(transformedData);
        } else {
          setDataInventory([]);
        }
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  // Lấy danh sách mã bộ phận
  const fetchDataBp = async () => {
    try {
      // if (
      //   userLogin &&
      //   userLogin.branchId !== null &&
      //   userLogin.branchId !== undefined
      // ) {
      //   const response = await repositoryPos.get(
      //     `/api/v1/TblDepartment/get-all?branchId=${userLogin?.branchId}`
      //   );
      //   if (response && response.success) {
      //     const transformedData = response.data.map((item: any) => ({
      //       value: String(item.departmentId),
      //       label: item.deparmentCode + " - " + item.name,
      //     }));
      //     setDataDepartment(transformedData);
      //   } else {
      //     setDataDepartment([]);
      //   }
      // } else {
      //   const response = await repositoryPos.get(
      //     `/api/v1/TblDepartment/get-all`
      //   );
      //   if (response && response.success) {
      //     const transformedData = response.data.map((item: any) => ({
      //       value: String(item.departmentId),
      //       label: item.departmentId + " - " + item.name,
      //     }));
      //     setDataDepartment(transformedData);
      //   } else {
      //     setDataDepartment([]);
      //   }
      // }
      if (
        formSeachInput.getValues().Cnids &&
        formSeachInput.getValues().Cnids.length > 0
      ) {
        const response = await repositoryPos.get(
          `/api/v1/TblDepartment/get-all?branchId=${
            formSeachInput.getValues().Cnids
          }`,
        );
        if (response && response.success) {
          const transformedData = response.data
            .filter((i: any) => {
              if (!i.departmentId || !i.name) {
                return false;
              }

              if (String(i.deparmentCode) === "KDOL") {
                return String(i.departmentId) === "1293";
              }

              return true;
            })
            .map((item: any) => ({
              value: String(item.departmentId),
              label: item.deparmentCode + " - " + item.name,
            }));
          setDataDepartment(transformedData);
        } else {
          setDataDepartment([]);
        }
      } else {
        const response = await repositoryPos.get(
          `/api/v1/TblDepartment/get-all`,
        );
        if (response && response.success) {
          const transformedData = response.data
            .filter((i: any) => {
              if (!i.departmentId || !i.name) {
                return false;
              }

              if (String(i.deparmentCode) === "KDOL") {
                return String(i.departmentId) === "1293";
              }

              return true;
            })
            .map((item: any) => ({
              value: String(item.departmentId),
              label: item.deparmentCode + " - " + item.name,
            }));
          setDataDepartment(transformedData);
        } else {
          setDataDepartment([]);
        }
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  // Lấy danh sách mã khách hàng
  const fetchDataCustomer = async (isCallFirst: boolean) => {
    try {
      let url = `/api/v1/TblDmCustomer/get-list?Skip=0&Take=50`;

      if (
        debounceKeySearchCustomer &&
        debounceKeySearchCustomer.length > 2 &&
        !formSeachInput.getValues()?.KHids
      ) {
        url += `&KeySearch=${debounceKeySearchCustomer}`;
      } else if (
        debounceKeySearchCustomer &&
        debounceKeySearchCustomer.length > 2 &&
        formSeachInput.getValues()?.KHids
      ) {
        url += `&KeySearch=${debounceKeySearchCustomer.split("-")[0]?.trim()}`;
      }

      const response = await repositoryPos.get(url);
      if (response && response.success) {
        const transformedData = response.data
          .filter((item: any) => item.name !== null && item.id !== null)
          .map((item: any) => ({
            value: String(item.id),
            label: String(item.code) + " - " + item.name,
          }))
          .filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex((t) => t.value === item.value),
          );

        if (isCallFirst) {
          setDataCustomer(transformedData);
        }
        setDataCustomerSearch(transformedData);
      } else {
        setDataCustomer([]);
        setDataCustomerSearch([]);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  //Lấy danh sách Mã sản phẩm
  const DataItemCode = async (keySearch?: string) => {
    try {
      let url = `/api/v1/TblItem/get-select?Page=30`;

      if (keySearch && keySearch.length > 0) {
        // Ưu tiên keySearch nếu tồn tại
        url += `&Key=${keySearch}`;
      } else if (
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.MaSp
      ) {
        // Nếu không có keySearch, sử dụng _searchJson.MaSp
        url += `&Key=${_searchJson.MaSp}`;
      }
      const response = await repositoryPos.get(url);
      if (response && response.success) {
        // const transformedData = response.data
        //   ?.filter((i: any) => i.maSp && i.tenSp)
        //   .map((branch: any) => ({
        //     value: branch.maSp,
        //     label: branch.maSp + " - " + branch.tenSp,
        //   }));
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text)
          .map((branch: any) => ({
            value: branch.value,
            label: branch.text,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItemCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  //Lấy list nhân viên
  const fetchSelectEmployee = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-select",
    );
    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data
        .filter((item: any) => item.value !== null && item.text !== null)
        .map((i: any) => ({
          value: i.att1,
          label: ` ${i.att1} - ${i.text}`,
        }));
      setDataEmployee(filteredData);
    }
  };

  // Sử dụng debounce để trì hoãn việc gọi API
  const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    if (value.length >= 3) {
      DataItemCode(value); // Gọi API với từ khóa tìm kiếm
    }
  }, 500);

  // console.log("formSeachInput.getValues()", formSeachInput.getValues());

  // Lưu key search
  // useEffect(() => {
  //   const runAsyncFunctions = async () => {
  //     await SaveKeySearch(formSeachInput, null, 1);
  //   };
  //   const nextuse = async () => {
  //     await Promise.all([
  //       fetchDataBranch(),
  //       fetchDataKho(),
  //       fetchDataBp(),
  //       fetchDataCustomer(),
  //     ]);
  //     await runAsyncFunctions();
  //     await fetchData();
  //   };
  //   nextuse();
  // }, []);
  useEffect(() => {
    const runAsyncFunctions = async () => {
      await Promise.all([
        fetchDataBp(),
        fetchDataBranch(),
        fetchDataKho(),
        fetchDataCustomer(true),
        DataItemCode(),
        fetchSelectEmployee(),
      ]);
    };
    const nextuse = async () => {
      await runAsyncFunctions();
      // await fetchData();
    };
    nextuse();
  }, []);

  useEffect(() => {
    if (debounceKeySearchCustomer && debounceKeySearchCustomer.length > 2) {
      fetchDataCustomer(false);
    } else {
      setDataCustomerSearch(dataCustomer);
    }
  }, [debounceKeySearchCustomer]);

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination, isCallFirst]);

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  const exportDataExcel = async () => {
    open(); // Hiển thị loading
    try {
      // Khởi tạo URL với các tham số phân trang
      let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
        pagination.pageSize
      }`;

      // Thêm các tham số tìm kiếm nếu có
      if (formSeachInput.getValues().keySearch) {
        url += `&KeySearch=${formSeachInput.getValues().keySearch}`;
      }
      if (formSeachInput.getValues().MaKenh) {
        url += `&MaKenh=${formSeachInput.getValues().MaKenh}`;
      }
      if (formSeachInput.getValues().MaNvkd) {
        url += `&MaNvkd=${formSeachInput.getValues().MaNvkd}`;
      }
      if (formSeachInput.getValues().MaSp) {
        url += `&MaSp=${formSeachInput.getValues().MaSp}`;
      }
      if (formSeachInput.getValues().Sdt) {
        url += `&Sdt=${formSeachInput.getValues().Sdt}`;
      }
      if (formSeachInput.getValues().Cnids) {
        url += `&Cnids=${formSeachInput.getValues().Cnids}`;
      }
      if (formSeachInput.getValues().StartTime) {
        url += `&StartTime=${formatDateNotTimeZone(
          formSeachInput.getValues().StartTime,
        )}`;
      }
      if (formSeachInput.getValues().EndTime) {
        url += `&EndTime=${formatDateNotTimeZone(
          formSeachInput.getValues().EndTime,
        )}`;
      }
      if (
        formSeachInput.getValues().KhoIds &&
        formSeachInput.getValues().KhoIds !== ""
      ) {
        url += `&KhoIds=${formSeachInput.getValues().KhoIds}`;
      }
      if (formSeachInput.getValues().Bpids) {
        url += `&Bpids=${formSeachInput.getValues().Bpids}`;
      }
      if (formSeachInput.getValues().KHids) {
        url += `&KHids=${formSeachInput.getValues().KHids}`;
      }

      // Xây dựng URL API cuối cùng
      const baseUrl = `/api/v1/ExportExcel/export-item-sales-daily${url}`;
      const _url = BASE_API_MDM + baseUrl;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename = "bao_cao_ban_hang_theo_ngay.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!",
      );
    } finally {
      close(); // Đóng loading
    }
  };
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useHotkeys([
    [
      "enter",
      () => {
        if (isCallFirst) {
          fetchData();
        } else if (!isCallFirst && innitStateSearch.Cnids.length === 0) {
          setIsCallFirst(false);
        } else {
          setIsCallFirst(true);
        }
      },
    ],
  ]);

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />

      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
        }}
        ref={headerRef}
      >
        <Group justify="space-between">
          <BreadcrumbLayout1></BreadcrumbLayout1>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => {
              if (
                (formSeachInput.getValues().Cnids &&
                  formSeachInput.getValues().Cnids.length > 0) ||
                (formSeachInput.getValues().Bpids &&
                  String(formSeachInput.getValues().Bpids) === "1293")
              ) {
                exportDataExcel();
              } else {
                NotificationExtension.Fails(
                  "Chỉ được export excel theo từng chi nhánh hoặc của bộ phận KDOL !",
                );
              }
            }}
            // disabled={!isCallFirst}
          >
            Export Excel
          </Button>
        </Group>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Grid style={{ width: "100%" }} mt={10}>
            <Grid.Col span={sizeGrid}>
              <Input
                size="sm"
                placeholder="Từ khoá"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={formSeachInput.key("keySearch")}
                {...formSeachInput.getInputProps("keySearch")}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    fetchData();
                    // localStorage.setItem(
                    //   "allValueKeySearch",
                    //   JSON.stringify({
                    //     ...formSeachInput.getValues(),
                    //     url: String(window.location.pathname),
                    //   })
                    // );
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Chọn ngày bắt đầu"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                key={formSeachInput.key("StartTime")}
                {...formSeachInput.getInputProps("StartTime")}
                value={
                  formSeachInput.getValues().StartTime
                    ? dayjs(formSeachInput.getValues().StartTime).toDate()
                    : null // Nếu không có giá trị, đặt null
                }
                onChange={(date) =>
                  formSeachInput.setFieldValue(
                    "StartTime",
                    date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : "",
                  )
                }
                clearable
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Chọn ngày kết thúc"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                maxDate={
                  formSeachInput.getValues().StartTime
                    ? addMonths(
                        new Date(formSeachInput.getValues().StartTime),
                        1,
                      )
                    : undefined
                }
                key={formSeachInput.key("EndTime")}
                {...formSeachInput.getInputProps("EndTime")}
                value={
                  formSeachInput.getValues().EndTime
                    ? dayjs(formSeachInput.getValues().EndTime).toDate()
                    : null
                }
                onChange={(date) =>
                  formSeachInput.setFieldValue(
                    "EndTime",
                    date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : "",
                  )
                }
                clearable
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <Select
                searchable
                clearable
                placeholder="Chọn chi nhánh"
                size="sm"
                leftSection={<IconBrandBootstrap color="#15aabf" />}
                data={dataBranch.map((item: any) => {
                  return {
                    label: `${item?.att2} - ${item?.text}`,
                    value: String(item?.value ?? ""),
                  };
                })}
                value={
                  dataBranch.length > 0 ? formSeachInput.getValues().Cnids : ""
                }
                onChange={async (e) => {
                  formSeachInput.setFieldValue("Cnids", e ? e.toString() : "");
                  formSeachInput.setFieldValue("KhoIds", "");
                  formSeachInput.setFieldValue("Bpids", "");

                  await fetchDataKho();
                  await fetchDataBp();
                }}

                // key={formSeachInput.key("Cnids")}
                // {...formSeachInput.getInputProps("Cnids")}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <Select
                key={`${formSeachInput.getValues().Cnids}-${
                  formSeachInput.getValues().KhoIds
                }`} // Buộc render lại khi Cnids hoặc KhoIds thay đổi
                size="sm"
                placeholder="Chọn kho"
                searchable
                clearable
                leftSection={
                  <IconBuildingWarehouse size={20} color="#15aabf" />
                }
                data={dataInventory}
                value={
                  dataInventory.length > 0
                    ? formSeachInput.getValues().KhoIds
                    : ""
                }
                // key={formSeachInput.key("KhoIds")}
                // {...formSeachInput.getInputProps("KhoIds")}
                onChange={(e, value) => {
                  formSeachInput.setFieldValue("KhoIds", e ? e.toString() : "");
                }}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <Select
                key={`${formSeachInput.getValues().Cnids}-${
                  formSeachInput.getValues().Bpids
                }`} // Buộc render lại khi Cnids hoặc KhoIds thay đổi
                size="sm"
                placeholder="Chọn bộ phận"
                searchable
                clearable
                leftSection={<IconUsers size={20} color="#15aabf" />}
                data={dataDepartment}
                value={
                  dataDepartment.length > 0
                    ? formSeachInput.getValues().Bpids
                    : ""
                }
                // key={formSeachInput.key("Bpids")}
                // {...formSeachInput.getInputProps("Bpids")}
                onChange={(e, value) => {
                  formSeachInput.setFieldValue("Bpids", e ? e.toString() : "");
                }}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <Select
                size="sm"
                placeholder="Mã sản phẩm"
                clearable
                searchable
                data={dataItemCode}
                value={
                  dataItemCode.length > 0 ? formSeachInput.getValues().MaSp : ""
                }
                leftSection={<IconBarcode size={20} color="#15aabf" />}
                onSearchChange={(value) => {
                  debouncedDataItemCode(value); // Sử dụng debounce
                }}
                // key={formSeachInput.key("MaSp")}
                // {...formSeachInput.getInputProps("MaSp")}
                onChange={(e, value) => {
                  formSeachInput.setFieldValue("MaSp", e ? e.toString() : "");
                }}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Select
                size="sm"
                placeholder="Chọn khách hàng"
                searchable
                clearable
                leftSection={<IconUsers size={20} color="#15aabf" />}
                data={dataCustomerSearch}
                value={
                  dataCustomerSearch.length > 0
                    ? formSeachInput.getValues().KHids
                    : ""
                }
                searchValue={keySearchCustomer}
                onSearchChange={setKeySearchCustomer}
                // key={formSeachInput.key("KHids")}
                // {...formSeachInput.getInputProps("KHids")}
                onChange={(e, value) => {
                  formSeachInput.setFieldValue("KHids", e ? e.toString() : "");
                }}
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Input
                size="sm"
                placeholder="SĐT người bán"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={formSeachInput.key("Sdt")}
                {...formSeachInput.getInputProps("Sdt")}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    fetchData();
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Select
                size="sm"
                placeholder="Mã nhân viên kinh doanh"
                clearable
                searchable
                data={dataEmployee}
                value={
                  dataEmployee.length > 0
                    ? formSeachInput.getValues().MaNvkd
                    : ""
                }
                leftSection={<IconBarcode size={20} color="#15aabf" />}
                onChange={(e, value) => {
                  formSeachInput.setFieldValue("MaNvkd", e ? e.toString() : "");
                }}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <Input
                size="sm"
                placeholder="Mã kênh"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={formSeachInput.key("MaKenh")}
                {...formSeachInput.getInputProps("MaKenh")}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    fetchData();
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Button
                type="submit"
                leftSection={<IconSearch size={20} />}
                color="blue"
                variant="outline"
                onClick={() => {
                  if (isCallFirst) {
                    fetchData();
                  } else if (
                    !isCallFirst &&
                    innitStateSearch.Cnids.length === 0
                  ) {
                    setIsCallFirst(false);
                  } else {
                    setIsCallFirst(true);
                  }
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </Box>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default GeneralSalesStatement;
